import React from 'react';
import BlogDeletedSection from '../../../../sections/AdminDashboard/Content/Blog/BlogDeleted';

const BlogDeleted = () => {
  return <BlogDeletedSection />;
};

export default BlogDeleted;

